module.exports = __webpack_public_path__ + "static/media/keterangan_bpjs_tidak_aktif.e7d24717.jpg";